import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CdekCourierEstimatedTimeIntervalDto
*  Временной интервал доставки.
*/
export class CdekCourierEstimatedTimeIntervalDto extends ActiveModel {

/**
  * start
  * Начало интервала.
  */
  @ActiveField('')
  start: string = ''


/**
  * end
  * Конец интервала.
  */
  @ActiveField('')
  end: string = ''
}
